<template>
  <Breadcrumbs
    title="Ageing Analysis Report"
    :breadcrumbs="[
      { label: 'Reports', path: '' },
      { label: 'Ageing Analysis Report', path: '/invoice' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <AgeingAnalysisReportForm />
    </div>
  </div>
</template>

<script>
import AgeingAnalysisReportForm from './ageingAnalysisReportForm.vue';

export default {
  name: "AgeingAnalysisPage",
  components: {
    AgeingAnalysisReportForm,
  },
};
</script>